import { render, staticRenderFns } from "./popup_error_phone.vue?vue&type=template&id=58bed0be"
import script from "./popup_error_phone.vue?vue&type=script&lang=js"
export * from "./popup_error_phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports